import script from "./ModalOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalOverlay.vue?vue&type=script&setup=true&lang=js"

import "./ModalOverlay.vue?vue&type=style&index=0&id=660038b0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660038b0"]])

export default __exports__